<template>
  <div :class="grid ? 'col-md-' + grid : 'col-md-12'">
    <div class="form-group mb-2">
      <label class="d-block font-weight-bold">
        {{ label }}
        <span v-if="required" class="text-danger">*</span>
      </label>
      <div class="col-12 px-0" v-for="(item, i) in array" :key="i">
        <div
          class="d-inline-flex justify-content-start align-items-center mb-2"
        >
          <input
            class="mr-2"
            type="radio"
            v-bind:name="name ? name :item.id"
            v-bind:id="item.id"
            v-bind:value="item.id"
            v-model="valor"
            :required="required"
            @change="$emit('input', valor)"
          />
          <label class="form-check-label" v-html="item.value"> </label>
        </div>
        <!-- <label class="d-flex align-items-center">
					<input
						type="radio"
						v-bind:name="item.id"
						v-bind:id="item.id"
						v-bind:value="item.id"
						v-model="valor"
						:required="required"
						@change="$emit('input', valor)"
					/>
					<span class="pl-1" v-html="item.value"></span>
				</label> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["value", "grid", "name", "itens", "label", "required", "mt"],
  data() {
    return { valor: {}, array: [] };
  },
  beforeMount() {
    this.valor = this.value;
    if (Array.isArray(this.itens)) {
      this.array = this.itens;
    }
  },
  watch: {
    value(n, o) {
      this.valor = n;
    },
    itens(n, o) {
      this.array = n;
    },
  },
};
</script>
<style lang="css">
input[type="radio"] {
  height: 18px !important;
  width: 18px !important;
}

.form-check-label {
  font-weight: bold;
  font-size: 16px;
}
</style>
